import apiClient from './client';
import { GuardrailStats, OrdersByHour, PopularMenu, SalesResponse } from '../types/admin';

export const fetchSalesStats = async (range: 'daily' | 'monthly'): Promise<SalesResponse> => {
  const { data } = await apiClient.get<SalesResponse>('/appmanage/stats/sales', { params: { range } });
  return data;
};

export const fetchOrdersByHour = async (): Promise<OrdersByHour[]> => {
  const { data } = await apiClient.get<OrdersByHour[]>('/appmanage/stats/orders-by-hour');
  return data;
};

export const fetchPopularMenus = async (): Promise<PopularMenu[]> => {
  const { data } = await apiClient.get<PopularMenu[]>('/appmanage/stats/popular-menus');
  return data;
};

export const fetchGuardrailStats = async (): Promise<GuardrailStats> => {
  const { data } = await apiClient.get<GuardrailStats>('/appmanage/stats/guardrails');
  return data;
};
